export default "__VITE_ASSET__BE75aa71__"